<template>
  <div
    class="surveyCalculator"
    style="height: 100%"
    :style="{ 'background-color': backgroundColor }"
  >
    <b-container>
      <b-row>
        <h2>{{ $t(title) }}</h2>
        <div class="surveyCalculatorSubtitle">
          {{ $t("label_opinionSurvey_calculator_generalSample_title") }}
        </div>
        <div class="surveyCalculatorText">
          {{ $t("label_opinionSurvey_calculator_generalSample_description") }}
        </div>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div class="surveyCalculatorGridContainer">
            <div
              style="align-self: start"
              class="surveyCalculatorContainer surveyCalculatorFieldsContainer"
            >
              <b-container>
                <b-row>
                  <b-col cols="6" />
                  <b-col cols="6">
                    <b-container>
                      <b-row>
                        <b-col cols="4" />
                        <b-col cols="4" class="surveyCalculatorFieldTitle">
                          {{ $t("label_opinionSurvey_calculator_women") }}
                        </b-col>
                        <b-col cols="4" class="surveyCalculatorFieldTitle">
                          {{ $t("label_opinionSurvey_calculator_men") }}
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    cols="6"
                    class="surveyCalculatorFieldTitle"
                    style="padding-top: 11px"
                  >
                    {{ $t("label_opinionSurvey_calculator_totalStaff") }}
                  </b-col>
                  <b-col cols="6">
                    <b-container>
                      <b-row>
                        <b-col cols="4">
                          <form-input-numeric
                            class="surveyCalculatorField"
                            disabled
                            :value="totalWomen + totalMen"
                            min="0"
                          />
                        </b-col>
                        <b-col cols="4">
                          <form-input-numeric
                            class="surveyCalculatorField"
                            disabled
                            :value="totalWomen"
                            min="0"
                          />
                        </b-col>
                        <b-col cols="4">
                          <form-input-numeric
                            class="surveyCalculatorField"
                            disabled
                            :value="totalMen"
                            min="0"
                          />
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    cols="6"
                    class="surveyCalculatorFieldTitle"
                    style="padding-top: 11px"
                  >
                    {{ $t("label_opinionSurvey_calculator_sampleSize") }}
                  </b-col>
                  <b-col cols="6">
                    <b-container>
                      <b-row>
                        <b-col cols="4">
                          <form-input-numeric
                            class="surveyCalculatorField surveyCalculatorField-blue surveyCalculatorField-bold"
                            disabled
                            :value="strataMen + strataWomen"
                            min="0"
                          />
                        </b-col>
                        <b-col cols="4">
                          <form-input-numeric
                            class="surveyCalculatorField surveyCalculatorField-blue surveyCalculatorField-bold"
                            disabled
                            :value="strataWomen"
                            min="0"
                          />
                        </b-col>
                        <b-col cols="4">
                          <form-input-numeric
                            class="surveyCalculatorField surveyCalculatorField-blue surveyCalculatorField-bold"
                            disabled
                            :value="strataMen"
                            min="0"
                          />
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-col>
                </b-row>
              </b-container>
            </div>
            <div
              style="grid-row: 2; grid-column: 1; align-self: end"
              class="surveyCalculatorContainer surveyCalculatorFieldsContainer"
            >
              <b-container>
                <b-row>
                  <b-col cols="6" class="surveyCalculatorFieldTitle">
                    {{
                      $t("label_opinionSurvey_calculator_opinionSurveyProgress")
                    }}
                  </b-col>
                  <b-col cols="6">
                    <b-container>
                      <b-row>
                        <b-col cols="4" />
                        <b-col cols="4" class="surveyCalculatorFieldTitle">
                          {{ $t("label_opinionSurvey_calculator_women") }}
                        </b-col>
                        <b-col cols="4" class="surveyCalculatorFieldTitle">
                          {{ $t("label_opinionSurvey_calculator_men") }}
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    cols="6"
                    class="surveyCalculatorFieldTitle"
                    style="padding-top: 11px"
                  >
                    {{ $t("label_opinionSurvey_calculator_completedSurveys") }}
                  </b-col>
                  <b-col cols="6">
                    <b-container>
                      <b-row>
                        <b-col cols="4">
                          <form-input-numeric
                            class="surveyCalculatorField"
                            disabled
                            :value="totalSurveys"
                            min="0"
                          />
                        </b-col>
                        <b-col cols="4">
                          <form-input-numeric
                            class="surveyCalculatorField"
                            disabled
                            :value="totalCompletedWomen"
                            min="0"
                          />
                        </b-col>
                        <b-col cols="4">
                          <form-input-numeric
                            class="surveyCalculatorField"
                            disabled
                            :value="totalCompletedMen"
                            min="0"
                          />
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    cols="6"
                    class="surveyCalculatorFieldTitle"
                    style="padding-top: 11px"
                  >
                    {{ $t("label_opinionSurvey_calculator_neededToComplete") }}
                  </b-col>
                  <b-col cols="6">
                    <b-container>
                      <b-row>
                        <b-col cols="4">
                          <form-input-numeric
                            class="surveyCalculatorField surveyCalculatorField-bold"
                            :class="{
                              'surveyCalculatorField-red':
                                pendingWomen + pendingMen > 0,
                            }"
                            disabled
                            :value="pendingWomen + pendingMen"
                            min="0"
                          />
                        </b-col>
                        <b-col cols="4">
                          <form-input-numeric
                            class="surveyCalculatorField surveyCalculatorField-bold"
                            disabled
                            :value="pendingWomen"
                            :class="{
                              'surveyCalculatorField-red': pendingWomen > 0,
                            }"
                            min="0"
                          />
                        </b-col>
                        <b-col cols="4">
                          <form-input-numeric
                            class="surveyCalculatorField surveyCalculatorField-bold"
                            disabled
                            :value="pendingMen"
                            :class="{
                              'surveyCalculatorField-red': pendingMen > 0,
                            }"
                            min="0"
                          />
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-col>
                </b-row>
              </b-container>
            </div>
            <div
              style="grid-row-end: span 2"
              class="surveyCalculatorContainer surveyCalculatorFormulaTextContainer"
            >
              <div style="text-align: center">
                <img src="../assets/images/formula.png" />
              </div>
              <div class="surveyCalculatorFormulaText">
                <div v-html="$t('label_opinionSurvey_calculator_formula')" />
                <!--              <div><span class="surveyCalculatorFormulaVariable">n</span>Tamaño de la muestra poblacional a obtener
                              </div>
                              <div><span class="surveyCalculatorFormulaVariable">z</span>El valor obtenido mediante niveles de
                                confianza. Su valor es una constante, por lo general se
                                tienen dos valores dependiendo el grado de confianza que se desee siendo 99% el valor más alto (este
                                valor equivale a 2.58) y 95% (1.96) el valor mínimo aceptado para considerar la investigación como
                                confiable.
                              </div>
                              <div><span class="surveyCalculatorFormulaVariable">o</span>desviación estandar (0.5)</div>
                              <div><span class="surveyCalculatorFormulaVariable">N</span>Tamaño de la población total</div>
                              <div><span class="surveyCalculatorFormulaVariable">e</span>El límite aceptable de error muestral,
                                generalmente va del 1% (0.01) al 9% (0.09), siendo 5% (0.5)
                                el valor estándar usado en las investigaciones.
                              </div>
                              <div><span class="surveyCalculatorFormulaVariable">z</span>1.96</div>
                              <div><span class="surveyCalculatorFormulaVariable">o</span>0.5</div>
                              <div><span class="surveyCalculatorFormulaVariable">e</span>0.05</div>
                              <div>Fracción de muestreo 5/9</div>-->
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-checkbox v-model="stratifiedSample">
            {{ $t("label_opinionSurvey_calculator_stratifiedSample_checkbox") }}
          </b-form-checkbox>
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <b-row v-if="stratifiedSample">
        <div class="surveyCalculatorSubtitle">
          {{ $t("label_opinionSurvey_calculator_stratifiedSample") }}
        </div>
        <div class="surveyCalculatorText">
          {{
            $t("label_opinionSurvey_calculator_stratifiedSample_description")
          }}
        </div>
      </b-row>
    </b-container>
    <b-container class="surveyCalculatorStratified">
      <b-row v-if="stratifiedSample" style="margin-bottom: 50px">
        <b-col cols="12">
          <div
            class="surveyCalculatorContainer surveyCalculatorFieldsContainer"
          >
            <b-container>
              <b-row>
                <b-col cols="6" class="surveyCalculatorFieldTitle">
                  {{ $t("label_opinionSurvey_calculator_strata") }}
                </b-col>
                <b-col cols="6">
                  <b-row>
                    <b-col cols="4" class="surveyCalculatorFieldTitle">
                      {{ $t("label_opinionSurvey_calculator_sex") }}
                    </b-col>
                    <b-col cols="4" class="surveyCalculatorFieldTitle">
                      {{ $t("label_opinionSurvey_calculator_totalPopulation") }}
                    </b-col>
                    <b-col cols="4" class="surveyCalculatorFieldTitle">
                      {{
                        $t(
                          "label_opinionSurvey_calculator_stratified_sampleSize"
                        )
                      }}
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <template-opinion-survey-strata
                v-for="(strata, index) in stratas"
                :key="index"
                :strata="strata"
                :index="index"
                @update="setStrata"
                @delete="removeStrata"
              />
              <b-row>
                <b-col cols="6" class="surveyCalculatorFieldTitle">
                  <div class="surveyCalculatorAddStrata" @click="addStrata()">
                    +
                  </div>
                  <div
                    class="surveyCalculatorAddStrataText"
                    @click="addStrata()"
                  >
                    {{
                      $t("label_opinionSurvey_calculator_stratifiedSample_add")
                    }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <b-row>
                    <b-col cols="4" class="surveyCalculatorFieldTitle" />
                    <b-col cols="4" class="surveyCalculatorFieldTitle">
                      <form-input-numeric
                        style="margin: 4px"
                        class="surveyCalculatorField"
                        :value="totalInputStratas"
                        disabled
                        min="0"
                      />
                    </b-col>
                    <b-col cols="4" class="surveyCalculatorFieldTitle">
                      <form-input-numeric
                        style="margin: 4px"
                        class="surveyCalculatorField"
                        :value="totalStratas"
                        disabled
                        min="0"
                      />
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import TemplateOpinionSurveyStrata from "./template/_template-opinion-survey-strata";
import { mapGetters } from "vuex";
import { calculateStrata } from "../utils/commons";
import { axiosCall } from "@/utils/axiosCall";

export default {
  name: "SurveyCalculator",
  components: { TemplateOpinionSurveyStrata },
  props: {
    templateId: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: "label_opinionSurvey_calculator_title",
    },
    backgroundColor: {
      type: String,
      default: "#ffffff",
    },
  },
  data: function () {
    return {
      stratifiedSample: false,
      stratas: [],
      totalStratas: 0,
      totalInputStratas: 0,
      totalMen: 0,
      totalWomen: 0,
      strataMen: 0,
      strataWomen: 0,
      totalCompletedMen: 0,
      totalCompletedWomen: 0,
      pendingMen: 0,
      pendingWomen: 0,
      totalSurveys: 0,
    };
  },
  methods: {
    removeStrata: async function (index) {
      if (this.stratas[index].id) {
        await axiosCall({
          url: "OpinionSurveyStratasCalculations/" + this.stratas[index].id,
          method: "DELETE",
        });
      }
      this.stratas.splice(index, 1);
      if (this.stratas.length === 0) {
        this.addStrata();
      }
    },
    getStratas: async function () {
      const where = {};
      where["where"] = {};
      where["where"]["snapshotId"] = this.getCurrentSnapshot.snapshotId;
      await axiosCall({
        url: "OpinionSurveyStratasCalculations?filter=" + JSON.stringify(where),
        method: "GET",
      })
        .then((response) => {
          if (response.data.length === 0) {
            this.addStrata();
          } else {
            this.stratas = response.data;
            this.stratifiedSample = true;
          }
        })
        .catch(() => {
        });
    },
    setStrata: async function (strata) {
      strata.strata.women = strata.strata.women || 0;
      strata.strata.men = strata.strata.men || 0;

      await axiosCall({
        url: "OpinionSurveyStratasCalculations/",
        method: "PUT",
        data: strata.strata,
      }).then((response) => {
        this.stratas[strata.index].id = response.data.id;
      });
      this.calculateTotals();
    },
    calculateTotals() {
      this.totalStratas = 0;
      this.totalInputStratas = 0;
      this.stratas.map((strata) => {
        this.totalStratas =
          this.totalStratas + strata.strataWomen + strata.strataMen;
        this.totalInputStratas =
          this.totalInputStratas + strata.men + strata.women;
      });
    },
    addStrata() {
      this.stratas.push({
        name: "",
        strataWomen: 0,
        strataMen: 0,
        women: 0,
        men: 0,
        snapshotId: this.getCurrentSnapshot.snapshotId,
      });
    },
  },
  computed: {
    ...mapGetters(["getCurrentSnapshot"]),
  },
  created: async function () {
    await this.$store.dispatch("SNAPSHOTS_GET");
    await this.$store.dispatch("BUSINESS_GET");
    await this.getStratas();
    await axiosCall({
      url:
        "Surveys/getCompletedByGender/" +
        this.getCurrentSnapshot.snapshotId +
        "/" +
        this.templateId,
    })
      .then((resp) => {
        this.totalMen =
          resp.data.selfAssessment.selfAssessment_staff_responsibility_total_men;
        this.totalWomen =
          resp.data.selfAssessment.selfAssessment_staff_responsibility_total_women;
        this.strataMen = calculateStrata(this.totalMen);
        this.strataWomen = calculateStrata(this.totalWomen);
        this.totalCompletedWomen =
          resp.data.survey.optionList_opinionSurvey_basicInformation_qA_sex_female;
        this.totalCompletedMen =
          resp.data.survey.optionList_opinionSurvey_basicInformation_qA_sex_male;
        this.pendingMen = this.strataMen - this.totalCompletedMen;
        this.pendingWomen = this.strataWomen - this.totalCompletedWomen;
        this.totalSurveys = resp.data.total;
      })
      .catch(() => {
      });
  },
};
</script>

<style lang="scss" scoped>
.surveyCalculator {
  h2 {
    text-align: center;
    width: 100%;
    padding-top: 20px;
  }

  &Stratified {
    margin: 0 auto;
  }

  &AddStrata {
    background: #03a19c;
    border-radius: 8px;
    font-size: 32px;
    font-weight: bold;
    color: #ffffff;
    width: 37px;
    height: 39px;
    line-height: 38px;
    cursor: pointer;
    display: inline-block;
    margin-right: 13px;

    &Text {
      width: 250px;
      cursor: pointer;
      display: inline-block;
    }
  }

  .custom-control.custom-checkbox {
    padding-top: 18px;
    padding-bottom: 18px;
  }

  &GridContainer {
    display: grid;
    grid-template-columns: 56% 43%;
    grid-auto-rows: max-content;
    grid-gap: 1rem;
    justify-content: center;
    width: 100%;
  }

  &Field {
    margin: 8px;
    text-align: center;

    &-bold {
      border-width: 2px;
      font-weight: bold;
    }

    &-red {
      border-color: #f88787;
    }

    &-blue {
      border-color: #03a19c;
    }
  }

  &FieldTitle {
    font-size: 17px;
    font-weight: bold;
    text-align: center;
  }

  &Fields {
    &Container {
      padding: 17px 27px;
    }
  }

  &Formula {
    &Variable {
      margin-right: 20px;
    }

    &Text {
      font-size: 13px;
      text-align: justify;

      &Container {
        padding: 8px 17px;
      }
    }
  }

  &Container {
    border: 1px solid #707070;
    border-radius: 20px;
  }

  &Title {
    text-transform: uppercase;
    font-size: 24px;
    color: #000000;
    text-align: center;
    font-weight: bold;
    font-family: Oswald-Bold;
    margin-bottom: 12px;
    width: 100%;
  }

  &Text {
    margin-bottom: 12px;
    width: 100%;
    text-align: justify;
  }

  &Subtitle {
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 12px;
    width: 100%;
  }
}

@media (max-width: 990px) {
  .surveyCalculatorGridContainer {
    grid-template-columns: 100%;
  }
  .surveyCalculatorFieldsContainer {
    padding: 17px 0px;
  }
  .surveyCalculatorContainer {
    .container {
      .row {
        .col-6 {
          .container {
            padding: 8px;
          }

          &:first-child {
            width: 41.6%;
          }

          &:last-child {
            width: 58.3%;
          }
        }
      }
    }
  }
}

@media (max-width: 400px) {
  .surveyCalculatorContainer {
    .container {
      .row {
        .col-6 {
          padding: 0;
          margin: 0;

          .container {
            padding: 2px;

            .row {
              .col-4 {
                padding: 0px;
                margin: 0px;
              }
            }
          }

          &:first-child {
            width: 21.6%;
          }

          &:last-child {
            width: 78.3%;
          }
        }
      }
    }
  }
}

@media (min-width: 800px) {
  .surveyCalculatorStratified {
    max-width: 80%;
  }
}
</style>
